import {z} from 'zod'
import {ICalEventId} from '../ical/index.js'
import {ConnectionId} from '../connection/index.js'
import type {RecommendationSourceType} from './RecommendationSourceType.js'

export const ICalRecommendationSource = z.object({
  type: z.literal('ical' satisfies RecommendationSourceType),
  connectionId: ConnectionId,
  events: z.array(
    z.object({
      id: ICalEventId,
      uid: z.string(),
    }),
  ),
})
export type ICalRecommendationSource = z.infer<typeof ICalRecommendationSource>

export const CommitRecommendationSource = z.object({
  type: z.literal('github-commit' satisfies RecommendationSourceType),
  connectionId: ConnectionId,
  pushes: z.array(
    z.object({
      id: z.number(),
    }),
  ),
})
export type CommitRecommendationSource = z.infer<typeof CommitRecommendationSource>

export const JiraIssueRecommendationSource = z.object({
  type: z.literal('jira-issue' satisfies RecommendationSourceType),
  connectionId: ConnectionId,
  issues: z.array(
    z.object({
      id: z.string(),
      key: z.string(),
      historyStartId: z.string(),
      historyEndId: z.string().nullish(),
    }),
  ),
})
export type JiraIssueRecommendationSource = z.infer<typeof JiraIssueRecommendationSource>

export const RecommendationSource = z.union([
  ICalRecommendationSource,
  CommitRecommendationSource,
  JiraIssueRecommendationSource,
])
export type RecommendationSource = z.infer<typeof RecommendationSource>
